import axiosIns from "@/api/axios";


export const getListFieldApprovalCOO = async (params) => {
    const { token } = params;
    try {
        const response = await axiosIns.get(`/common/idp/coo/list-training?token=${token}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching field approval COO:', error);
        throw error;
    }
}

export const getListApprovalCOO = async (params) => {
    const { token, page = 1, limit = 10 } = params;
    try {
        const response = await axiosIns.get('/common/idp/coo/submitted-learnings', {
            params: {
                token,
                page,
                limit,
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching approval COO:', error);
        throw error;
    }
}

export const approveIDPByCOO = async (params) => {
    const { token, ids = [] } = params;
    try {
        const response = await axiosIns.post('/common/idp/coo/approve', {
            ids,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error approving IDP by COO:', error);
        throw error;
    }
}

export const rejectIDPByCOO = async (params) => {
    const { token, ids = [], reason = '' } = params;
    try {
        const response = await axiosIns.post('/common/idp/coo/reject', {
            ids,
            reason,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error rejecting IDP by COO:', error);
        throw error;
    }
}
